import React, { FC, memo } from 'react';

import { useVaultTokens } from '@contexts/vaults/VaultTokensContext';

import Loader from '@components/common/Loader';
import Popup from '@components/common/Modal/ModalWrapper/Popup';
import ViewAllFarms from '@components/vaults/ViewAllFarms';

import { FindFarmModalModalProps } from '@app-types/common/modal.types';

import useStyles from './styles.module';

const FindFarmModal: FC<FindFarmModalModalProps> = ({
  defaultFarms,
  chainId,
}) => {
  const { tokens, isLoading } = useVaultTokens();

  const { classes } = useStyles();

  return (
    <Popup
      title="Find a farm"
      classNameChildren={classes.modalChildren}
      classNameModal={classes.modal}
    >
      <div className={classes.box}>
        {tokens && !isLoading ? (
          <ViewAllFarms
            tokens={tokens}
            defaultFarms={defaultFarms}
            defaultChainId={chainId}
          />
        ) : (
          <Loader isCenter size={32} />
        )}
      </div>
    </Popup>
  );
};

export default memo(FindFarmModal);
